import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button/Button";
import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import Typography from "@material-ui/core/Typography/Typography";
import { getConf } from "@configuratorware/configurator-frontendgui/App/configuration";
import customClassName from "@configuratorware/configurator-frontendgui/App/Utils/customClassName";
import get from "lodash/get";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import getImageUrl from "@configuratorware/configurator-frontendgui/App/Utils/getImageUrl";
import { red } from "@material-ui/core/colors";
import { CloseMenuIcon } from "../../../../Icons";
import ConfigurationPicker from "../../Containers/ConfiguratorPicker";

const useStyles = makeStyles(
  (theme) => ({
    appbar: {
      root: {
        position: "absolute",
        width: "100%",
        top: 0,
        minHeight: theme.layout.appbar.heightSm,
        maxHeight: theme.layout.appbar.heightSm,
        [theme.breakpoints.up("sm")]: {
          minHeight: theme.layout.appbar.height,
          maxHeight: theme.layout.appbar.height,
        },
        [theme.breakpoints.up("xl")]: {
          minHeight: theme.layout.appbar.heightXL,
          maxHeight: theme.layout.appbar.heightXL,
        },
      },
    },
    toolbarHeaderWrapper: {
      padding: theme.spacing(0, 3),
      minHeight: theme.layout.appbar.heightSm,
      maxHeight: theme.layout.appbar.heightSm,
      [theme.breakpoints.up("sm")]: {
        minHeight: theme.layout.appbar.height,
        maxHeight: theme.layout.appbar.height,
        padding: theme.spacing(0, 6),
      },
      [theme.breakpoints.up("xl")]: {
        minHeight: theme.layout.appbar.heightXL,
        maxHeight: theme.layout.appbar.heightXL,
        padding: theme.spacing(0, 6),
      },
      background: theme.overrides.ToolBar.background,
      color: theme.overrides.ToolBar.color,

      "& h1": {
        fontWeight: "bold",
      },
      "& img": {
        display: "none",
        height: 25,
        [theme.breakpoints.up("sm")]: {
          display: "inherit",
          marginRight: theme.spacing(4) * theme.spacingMultiplicator.md,
        },
        [theme.breakpoints.up("lg")]: {
          marginRight: theme.spacing(4) * theme.spacingMultiplicator.lg,
        },
        [theme.breakpoints.up("xl")]: {
          marginRight: theme.spacing(6) * theme.spacingMultiplicator.xl,
          height: 40,
        },
      },
    },
    closeButton: {
      height: 48,
      paddingTop: 2,
      borderRadius: 100,
      //   textTransform: 'lowercase',
      marginLeft: "auto",
      padding: 0,
      "&:hover, &:active, &:focus": {
        background: "transparent",
      },
      [theme.breakpoints.up("sm")]: {
        paddingLeft: 5,
        marginRight: -22,
        paddingRight: 17,
        "&:hover": {
          background: "#959595",
        },
        "&:focus,&:active": {
          background: "#585858",
        },
      },

      "& .MuiButton-label": {
        marginRight: -8,
        marginLeft: "auto",
        width: 36,
        height: 36,
        borderRadius: 100,
        "&:hover": {
          background: "#959595",
          [theme.breakpoints.up("sm")]: {
            background: "transparent",
          },
        },
        " &:active, &:focus": {
          background: "#585858",
          [theme.breakpoints.up("sm")]: {
            background: "transparent",
          },
        },
        [theme.breakpoints.up("sm")]: {
          width: "auto",
          marginRight: 0,
          height: 1,
          marginLeft: 0,
        },
        [theme.breakpoints.up("xl")]: {
          minHeight: 1,
        },
        "& > span": {
          marginLeft: theme.layout.buttonIcon.paddingLeft + 4,
          display: "none",
          [theme.breakpoints.up("sm")]: {
            display: "inherit",
          },
        },
      },
      "& .MuiSvgIcon-root": {
        minWidth: "24px !important",
        height: theme.layout.appbar.heightSm - theme.spacing(4),
        width: "auto",
        padding: theme.spacing(2, 0),
        [theme.breakpoints.up("sm")]: {
          marginRight: -5.5,
          height: theme.layout.appbar.height - 15,
        },
        [theme.breakpoints.up("xl")]: {
          minHeight: theme.layout.appbar.height - 15,
        },
      },
    },
  }),
  {
    name: "Header",
  }
);

const Header = (props) => {
  const classes = useStyles(props);
  const host = getConf("network.host");

  const renderConfigurationPicker = () => <ConfigurationPicker {...props} />;
  const sendClosePostMessage = () => {
    const appConf = getConf();
    const targetOrigin = get(appConf, "addToCartPostMessageTargetOrigin", "*");
    window.parent.postMessage({ method: "closewindow" }, targetOrigin);
  };
  return (
    <div className={classes.root}>
      <AppBar className={classes.appbar} position="static">
        <Toolbar classes={{ regular: classes.toolbarHeaderWrapper }}>
          <div>
            <img
              src={`${getConf(
                "webserverDomain"
              )}/bundles/frontend/img/Logo.png`}
              alt="Klio-Eterna Konfigurator"
            />
          </div>
          <Typography
            className={classes.mainHeading}
            variant="h1"
            color="inherit"
          >
            {t("general.mainHeading")}
          </Typography>
          <Button
            disableRipple
            className={classes.closeButton}
            color="inherit"
            onClick={sendClosePostMessage}
          >
            <span>{t("general.closeLabel")}</span>
            <CloseMenuIcon />
          </Button>
        </Toolbar>
      </AppBar>
      {renderConfigurationPicker()}
    </div>
  );
};

Header.propTypes = {
  tools: PropTypes.array,
  steps: PropTypes.array,
  variants: PropTypes.array,
  selectedVariantIdentifier: PropTypes.string,
  title: PropTypes.string,
  switchSelectedAmount: PropTypes.func,
  VariantChooserComponent: PropTypes.elementType,
};

Header.defaultProps = {
  variants: [],
};

export default Header;
